import type { Component } from 'solid-js'
import type { MRRData } from '../../../features/revenue/domain/models/mrr'
import { ChartContainer, useChart } from '../charts'
import { getMRRChartOptions } from './MRRChart.vm'

interface MRRChartProps {
  data: MRRData[]
  formatCategory?: (dateStr: string) => string
}

const MRRChart: Component<MRRChartProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  useChart({
    data: () => props.data,
    chartRef: () => chartRef,
    buildOptions: (data) => {
      const dataType = data[0]?.data_type
      return getMRRChartOptions(data, dataType, props.formatCategory)
    }
  })

  return (
    <ChartContainer hasData={props.data && props.data.length > 0}>
      <div ref={chartRef} />
    </ChartContainer>
  )
}

export default MRRChart
